export const isSupportedLanguage = (lng: string): boolean => {
  return lng === "ja";
};

/**
 * ドキュメントの言語・書字方向を設定する。
 * sina は国内専用のため ja 固定（旧 i18n のブートストラップから引き継ぎ）。
 */
export const applyDocumentLanguage = (lng: string): void => {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("dir", "ltr");
  document.documentElement.setAttribute("lang", lng);
};

/**
 * URL 等で指定された言語を適用する。sina は ja のみサポートするため、
 * サポート外の言語が来た場合は何もしない（ネイティブが渡す lang パラメータの受け口）。
 */
export const loadAndApplyLanguage = (lng: string): void => {
  if (!isSupportedLanguage(lng)) return;
  applyDocumentLanguage(lng);
};
